import authRoutes from "@/router/routes/auth";
import Vertical from "@/layouts/vertical.vue";

export default [
    ...authRoutes,
  {
    path: "/",
    component: Vertical,
    authRequired: true,
    children: [
      {
        path: "/",
        meta: {
          title: "Dashboard",
          authRequired: true,
        },
        redirect: { name: "dashboard" }
      },
      {
        path: "/dashboard",
        name: "dashboard",
        meta: {
          title: "Dashboard",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/dashboard/index.vue"),
      },
      {
        path: "/vendor/my-services",
        name: "my-services",
        meta: {
          title: "خدماتي",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/my-services/index.vue"),
      },
      {
        path: "/vendor/my-services/create",
        name: "vendor-services-create",
        meta: {
          title: "خدماتي",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/my-services/create.vue"),
      },
      {
        path: "/vendor/my-services/:id/edit",
        name: "vendor-services-edit",
        meta: {
          title: "خدماتي",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/my-services/edit.vue"),
      },
      {
        path: "/vendor/my-branches",
        name: "vendor-branches",
        meta: {
          title: "الفروع",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/my-branches/index.vue"),
      },
      {
        path: "/vendor/my-branches/create",
        name: "vendor-branches-create",
        meta: {
          title: "الفروع",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/my-branches/create.vue"),
      },
      {
        path: "/vendor/my-branches/:id/edit",
        name: "vendor-branches-edit",
        meta: {
          title: "الفروع",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/my-branches/create.vue"),
      },
      {
        path: "/vendor/appointments",
        name: "vendor-appointments",
        meta: {
          title: "الحجوزات",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/appointments/index.vue"),
      },
      {
        path: "/vendor/appointments/:id/details",
        name: "vendor-appointments-details",
        meta: {
          title: "تفاصيل الحجز",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/appointments/details.vue"),
      },
      {
        path: "/vendor/opening-times",
        name: "vendor-opening-times",
        meta: {
          title: "أوقات الدوام",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/vendor/opening-times/index.vue")
      },
      {
        path: "/reports",
        name: "reports",
        meta: {
          title: "التقارير",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/stats/index.vue"),
      },
      {
        path: "/revenues",
        name: "revenues",
        meta: {
          title: "الإيرادات",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/revenues/index.vue"),
      },
      {
        path: "profile-settings",
        name: "profile-settings",
        meta: {
          title: "الحساب الشخصي",
          authRequired: true,
          roles: ['vendor']
        },
        component: () => import("../views/pages/profile/settings/index.vue")
      }
    ]
  },


  /*{
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/basic")
  },
  {
    path: '/auth/signin-basic',
    name: 'signin-basic',
    meta: {
      title: "Signin Basic", authRequired: true,
    },
    component: () => import('../views/auth/signin/basic')
  },
  {
    path: '/auth/signin-cover',
    name: 'signin-cover',
    meta: {
      title: "Signin Cover", authRequired: true,
    },
    component: () => import('../views/auth/signin/cover')
  },
  {
    path: '/auth/signup-basic',
    name: 'signup-basic',
    meta: {
      title: "Signup Basic", authRequired: true,
    },
    component: () => import('../views/auth/signup/basic')
  },
  {
    path: '/auth/signup-cover',
    name: 'signup-cover',
    meta: {
      title: "Signup Cover", authRequired: true,
    },
    component: () => import('../views/auth/signup/cover')
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/cover')
  },*/
];